// extracted by mini-css-extract-plugin
module.exports = {"inicio":"Inicio_inicio__2RDig","cards":"Inicio_cards__2iBnR","logos":"Inicio_logos__2GfBq"};